import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Optional, ɵɵdefineNgModule, ɵɵdefineInjector, NgModule, SkipSelf } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, shareReplay } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { LocalService } from '@akeela/local-storage';
import { __decorate, __param, __metadata } from 'tslib';

class AkeelaPropertiesConfig {
}

class AkeelaConfigConst {
}
AkeelaConfigConst.urlApi = 'http://54.225.6.218:8080';
AkeelaConfigConst.urlFront = 'http://akcredit.akeela.co';
AkeelaConfigConst.uriPropertiesPrefix = 'AkAppProperties';
AkeelaConfigConst.useMock = false;

class AkeelaPropertiesConfigService {
    constructor(config) {
        this.akeelaWorkflowConfig = new AkeelaPropertiesConfig();
        if (config) {
            this.options = config;
        }
    }
    set options(opt) {
        this.akeelaWorkflowConfig.urlApi = (opt && opt.urlApi) ? opt.urlApi : AkeelaConfigConst.urlApi;
        this.akeelaWorkflowConfig.urlFront = (opt && opt.urlFront) ? opt.urlFront : AkeelaConfigConst.urlFront;
        this.akeelaWorkflowConfig.useMock = (opt && opt.useMock) ? opt.useMock : AkeelaConfigConst.useMock;
        this.akeelaWorkflowConfig.uriPropertiesPrefix = ((opt && opt.uriPropertiesPrefix) || opt.uriPropertiesPrefix === '') ?
            opt.uriPropertiesPrefix : AkeelaConfigConst.uriPropertiesPrefix;
    }
    get urlApi() {
        return this.akeelaWorkflowConfig.urlApi + this.akeelaWorkflowConfig.uriPropertiesPrefix;
    }
    get urlFront() {
        return this.akeelaWorkflowConfig.urlFront;
    }
    get useMock() {
        return this.akeelaWorkflowConfig.useMock;
    }
}
/** @nocollapse */ AkeelaPropertiesConfigService.ɵfac = function AkeelaPropertiesConfigService_Factory(t) { return new (t || AkeelaPropertiesConfigService)(ɵɵinject(AkeelaPropertiesConfig, 8)); };
/** @nocollapse */ AkeelaPropertiesConfigService.ɵprov = ɵɵdefineInjectable({ token: AkeelaPropertiesConfigService, factory: AkeelaPropertiesConfigService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaPropertiesConfigService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaPropertiesConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

const entry_point = [
    {
        identifier: '442',
        description: null,
        name: 'credit$credit_section_incomplete$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_section_incomplete',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '443',
        description: null,
        name: 'credit$credit_father$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_father',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '451',
        description: null,
        name: 'credit$father_credit_section_incomplete$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/father_credit_section_incomplete',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '452',
        description: null,
        name: 'multiproduct$sheet_steps$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/sheet_steps',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '449',
        description: null,
        name: 'credit$credit_action_status$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_action_status',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '453',
        description: null,
        name: 'credit$credit_guarantor_indicators$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_guarantor_indicators',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '227',
        description: null,
        name: 'app_properties$bank$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/bank',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '228',
        description: null,
        name: 'app_properties$bank$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/bank',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '229',
        description: null,
        name: 'app_properties$banks$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/banks',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '230',
        description: null,
        name: 'app_properties$citys$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/citys',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '231',
        description: null,
        name: 'app_properties$countrys$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/countrys',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '240',
        description: null,
        name: 'app_properties$reload$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/reload',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '266',
        description: null,
        name: 'credit$send_credit_analysis_cp$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/send_credit_analysis_cp',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '267',
        description: null,
        name: 'credit$terms_and_conditions_credit$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/terms_and_conditions_credit',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '268',
        description: null,
        name: 'email_sender$sendMail$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/email_sender/sendMail',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '269',
        description: null,
        name: 'email_sender$getEmailMessage$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/email_sender/getEmailMessage',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '270',
        description: null,
        name: 'entity_table$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/entity_table/',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '271',
        description: null,
        name: 'financial$bank_account$delete',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/bank_account',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'DELETE',
        urlTemplate: null
    }, {
        identifier: '272',
        description: null,
        name: 'financial$bank_account$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/bank_account',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '273',
        description: null,
        name: 'financial$bank_account$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/bank_account',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '274',
        description: null,
        name: 'financial$bank_account_config$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/bank_account_config',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '275',
        description: null,
        name: 'financial$banking_movement$delete',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/banking_movement',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'DELETE',
        urlTemplate: null
    }, {
        identifier: '276',
        description: null,
        name: 'financial$banking_movement$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/banking_movement',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '277',
        description: null,
        name: 'financial$banking_movement_config$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/banking_movement_config',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '278',
        description: null,
        name: 'financial$expenses$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/expenses',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '279',
        description: null,
        name: 'financial$expenses$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/expenses',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '280',
        description: null,
        name: 'financial$income$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/income',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '281',
        description: null,
        name: 'financial$income$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/income',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '282',
        description: null,
        name: 'financial$ivadeclarations_config$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/ivadeclarations_config',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '283',
        description: null,
        name: 'financial$tax_declarations$delete',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/tax_declarations',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'DELETE',
        urlTemplate: null
    }, {
        identifier: '284',
        description: null,
        name: 'financial$tax_declarations$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/financial/tax_declarations',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '285',
        description: null,
        name: 'credit$credit_prox_step$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_prox_step',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '286',
        description: null,
        name: 'multiproduct$credit_section$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/credit_section',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '287',
        description: null,
        name: 'multiproduct$credit_section$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/credit_section',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '288',
        description: null,
        name: 'multiproduct$multiproduct_configuration$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/multiproduct_configuration',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '289',
        description: null,
        name: 'multiproduct$section_multiproduct_configuration$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/section_multiproduct_configuration',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '290',
        description: null,
        name: 'multiproduct$section_num_items_val$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/section_num_items_val',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '291',
        description: null,
        name: 'credit$section_status$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/section_status',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '292',
        description: null,
        name: 'multiproduct$step$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/step',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '293',
        description: null,
        name: 'multiproduct$step_children_configuration$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/step_children_configuration',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '294',
        description: null,
        name: 'multiproduct$step_configuration$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/step_configuration',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '296',
        description: null,
        name: 'multiproduct$step_multiproduct_configuration$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/step_multiproduct_configuration',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '297',
        description: null,
        name: 'credit$step_status$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/step_status',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '298',
        description: null,
        name: 'multiproduct$validate_section$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/validate_section',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '299',
        description: null,
        name: 'payment_calculator$amortization_table$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/payment_calculator/amortization_table',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '300',
        description: null,
        name: 'payment_calculator$config_amortization_table$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/payment_calculator/config_amortization_table',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '301',
        description: null,
        name: 'payment_calculator$monthly_fee$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/payment_calculator/monthly_fee',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '302',
        description: null,
        name: 'person$affiliate_user$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/affiliate_user',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '303',
        description: null,
        name: 'person$business_size$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/business_size',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '304',
        description: null,
        name: 'person$change_psw$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/change_psw',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '305',
        description: null,
        name: 'person$confirm_user_email$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/confirm_user_email',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '306',
        description: null,
        name: 'person$create_client_user$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/create_client_user',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '307',
        description: null,
        name: 'person$create_password$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/create_password',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '309',
        description: null,
        name: 'person$exists_email$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/exists_email',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '310',
        description: null,
        name: 'person$exists_username$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/exists_username',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '311',
        description: null,
        name: 'person$login$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/login',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '313',
        description: null,
        name: 'person$organization$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/organization',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '314',
        description: null,
        name: 'person$organization$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/organization',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '399',
        description: null,
        name: 'requirements$transaction_requirements$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/transaction_requirements',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '295',
        description: null,
        name: 'multiproduct$step_father_configuration$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/step_father_configuration',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '401',
        description: null,
        name: 'person$profile$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/profile',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '400',
        description: null,
        name: 'credit$credit_untaken$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_untaken',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '411',
        description: null,
        name: 'person$approval_authority_level$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/approval_authority_level',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '315',
        description: null,
        name: 'person$person$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/person',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '316',
        description: null,
        name: 'person$person$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/person',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '317',
        description: null,
        name: 'person$person$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/person',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '318',
        description: null,
        name: 'person$person_type$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/person_type',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '320',
        description: null,
        name: 'person$person_identity$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/person_identity',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '321',
        description: null,
        name: 'person$organization_identity$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/organization_identity',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '322',
        description: null,
        name: 'person$search_users$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/search_users',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '323',
        description: null,
        name: 'person$exists_password$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/exists_password',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '325',
        description: null,
        name: 'product_plan_rate$economic_activities$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/economic_activities',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '326',
        description: null,
        name: 'product_plan_rate$father_products$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/father_products',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '327',
        description: null,
        name: 'product_plan_rate$legal_forms$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/legal_forms',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '328',
        description: null,
        name: 'product_plan_rate$payment_method_types$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/payment_method_types',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '329',
        description: null,
        name: 'product_plan_rate$payment_methods$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/payment_methods',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '330',
        description: null,
        name: 'product_plan_rate$person_market_types$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/person_market_types',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '331',
        description: null,
        name: 'product_plan_rate$plan$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/plan',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '332',
        description: null,
        name: 'product_plan_rate$plans$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/plans',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '333',
        description: null,
        name: 'product_plan_rate$product$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/product',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '334',
        description: null,
        name: 'product_plan_rate$products$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/products',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '335',
        description: null,
        name: 'product_plan_rate$person_market_type$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/person_market_type',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '336',
        description: null,
        name: 'product_plan_rate$product-is_brothers$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product_plan_rate/product/is_brothers',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '337',
        description: null,
        name: 'product$product-products$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product/products',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '338',
        description: null,
        name: 'product$person_market_types$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product/person_market_types',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '339',
        description: null,
        name: 'product$legal_forms$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product/legal_forms',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '340',
        description: null,
        name: 'product$economic_activities$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product/economic_activities',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '341',
        description: null,
        name: 'product$product$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product/product',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '342',
        description: null,
        name: 'product$product_code$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product/product_code',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '343',
        description: null,
        name: 'product$person_market_type$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/product/person_market_type',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '344',
        description: null,
        name: 'cash_account$transaction$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/transaction',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '346',
        description: null,
        name: 'cash_account$transaction_origin_types$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/transaction_origin_types',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '347',
        description: null,
        name: 'cash_account$cash_account$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/cash_account',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '348',
        description: null,
        name: 'cash_account$contacts$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/contacts',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '349',
        description: null,
        name: 'cash_account$person_cash_accounts$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/person_cash_accounts',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '232',
        description: null,
        name: 'app_properties$getCurrency$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/getCurrency',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '233',
        description: null,
        name: 'app_properties$currency_by_id$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/currency_by_id',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '234',
        description: null,
        name: 'app_properties$currency_conversion$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/currency_conversion',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '235',
        description: null,
        name: 'app_properties$currency_conversion_id$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/currency_conversion_id',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '236',
        description: null,
        name: 'app_properties$getDecimalScale$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/getDecimalScale',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '237',
        description: null,
        name: 'app_properties$getLanguage$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/getLanguage',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '238',
        description: null,
        name: 'app_properties$getProperty$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/getProperty',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '353',
        description: null,
        name: 'cash_account$transactions$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/transactions',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '376',
        description: null,
        name: 'cash_account$reason_why$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/reason_why',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '377',
        description: null,
        name: 'cash_account$cash_account_transactions$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/cash_account_transactions',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '381',
        description: null,
        name: 'person$organization$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/organization',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '382',
        description: null,
        name: 'person$endusers_person$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/endusers_person',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '383',
        description: null,
        name: 'person$reset_password$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/reset_password',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '387',
        description: null,
        name: 'credit$executive_credits_config$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/executive_credits_config',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '388',
        description: null,
        name: 'credit$queue_config$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/queue_config',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '390',
        description: null,
        name: 'credit$credit_status$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_status',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '391',
        description: null,
        name: 'credit$credit_status_action$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_status_action',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '239',
        description: null,
        name: 'app_properties$localities$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/localities',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '241',
        description: null,
        name: 'app_properties$state$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/state',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '242',
        description: null,
        name: 'app_properties$states$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/states',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '243',
        description: null,
        name: 'app_properties$country$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/country',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '244',
        description: null,
        name: 'app_properties$city$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/city',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '245',
        description: null,
        name: 'app_properties$place$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/place',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '246',
        description: null,
        name: 'app_properties$currency$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/currency',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '247',
        description: null,
        name: 'app_properties$/getEndPoint$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/getEndPoint',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '248',
        description: null,
        name: 'archive$downloadFile$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/archive/downloadFile',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '249',
        description: null,
        name: 'archive$archive$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/archive/archive',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '250',
        description: null,
        name: 'archive$archive$delete',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/archive/archive',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'DELETE',
        urlTemplate: null
    }, {
        identifier: '251',
        description: null,
        name: 'archive$archive$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/archive/archive',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '252',
        description: null,
        name: 'auditLog$auditLog$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/auditlog/auditLog',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '254',
        description: null,
        name: 'auditLog$auditLog$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/auditlog/auditLog',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '255',
        description: null,
        name: 'credit$accredited$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/accredited',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '256',
        description: null,
        name: 'credit$associate_user_credit$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/associate_user_credit',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '257',
        description: null,
        name: 'credit$credit$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '258',
        description: null,
        name: 'credit$credit_dest_funds$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_dest_funds',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '259',
        description: null,
        name: 'credit$credit_dest_funds$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_dest_funds',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '260',
        description: null,
        name: 'credit$credit_operation_data$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_operation_data',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '262',
        description: null,
        name: 'credit$guarantor$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/guarantor',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '263',
        description: null,
        name: 'credit$my_credits$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/my_credits',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '264',
        description: null,
        name: 'credit$my_credits_config$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/my_credits_config',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '265',
        description: null,
        name: 'credit$request_credit$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/request_credit',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '380',
        description: null,
        name: 'transaction_attach$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/transaction_attach',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '392',
        description: null,
        name: 'credit$credit_status_responses$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_status_responses',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '393',
        description: null,
        name: 'credit$credit_accredited_indicators$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_accredited_indicators',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '395',
        description: null,
        name: 'credit$action_steps_status_credit$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/action_steps_status_credit',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '397',
        description: null,
        name: 'credit$relationship_transactions_config$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/relationship_transactions_config',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '398',
        description: null,
        name: 'credit$credit_taken$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_taken',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '379',
        description: null,
        name: 'cash_account$update_transactios_status$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/update_transactios_status',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '375',
        description: null,
        name: 'cash_account$accountNumber$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/accountNumber',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '374',
        description: null,
        name: 'cash_account$transaction_types$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_accounttransaction_types',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '384',
        description: null,
        name: 'person$endusers$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/endusers',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '402',
        description: null,
        name: 'requirements$upload_doc$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/upload_doc',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '403',
        description: null,
        name: 'requirements$transaction_requirement$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/transaction_requirement',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '413',
        description: null,
        name: 'person$business_unit$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/business_unit',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '419',
        description: null,
        name: 'requirements$all_docs_have_response$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/all_docs_have_response',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '423',
        description: null,
        name: 'person$endusers_profile$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/endusers_profile',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '404',
        description: null,
        name: 'credit$credit_response$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_response',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '412',
        description: null,
        name: 'person$job_title$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/job_title',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '416',
        description: null,
        name: 'person$create_system_user$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/create_system_user',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '424',
        description: null,
        name: 'person$associate_client_systemuser$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/associate_client_systemuser',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '439',
        description: null,
        name: 'requirements$transaction_requirements_status$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/transaction_requirements_status',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '405',
        description: null,
        name: 'person$enduser_profiles$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/enduser_profiles',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '408',
        description: null,
        name: 'person$assig_executive_credit$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/assig_executive_credit',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '409',
        description: null,
        name: 'person$inactivate_user_profile$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/inactivate_user_profile',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '414',
        description: null,
        name: 'requirements$requirement$delete',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/requirement',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'DELETE',
        urlTemplate: null
    }, {
        identifier: '417',
        description: null,
        name: 'app_properties$agencies$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/agencies',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '420',
        description: null,
        name: 'app_properties$menu$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/app_properties/menu',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '421',
        description: null,
        name: 'person$endusers_executive$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/endusers_executive',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '425',
        description: null,
        name: 'requirements$emission_expiration_dates$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/emission_expiration_dates',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '440',
        description: null,
        name: 'credit$my_credits_table$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/my_credits_table',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '410',
        description: null,
        name: 'person$assign_user_profile$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/assign_user_profile',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '415',
        description: null,
        name: 'requirements$upload_all_docs$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/upload_all_docs',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '418',
        description: null,
        name: 'credit$req_response$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/requirements/req_response',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '422',
        description: null,
        name: 'person$enduser$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/enduser',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '396',
        description: null,
        name: 'credit$related_transactions_config$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/related_transactions_config',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '358',
        description: null,
        name: 'cash_account$transaction_attach$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/transaction_attach',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '359',
        description: null,
        name: 'cash_account$transaction_status$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/transaction_status',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '360',
        description: null,
        name: 'credit$legal_accredited$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/legal_accredited',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '361',
        description: null,
        name: 'credit$business_size$put',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/business_size',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'PUT',
        urlTemplate: null
    }, {
        identifier: '363',
        description: null,
        name: 'credit$action_sections$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/action_sections',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '364',
        description: null,
        name: 'credit$credit_responses$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_responses',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '365',
        description: null,
        name: 'credit$natural_accredited$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/natural_accredited',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '369',
        description: null,
        name: 'cash_account$transaction_attach$post',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/transaction_attach',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'POST',
        urlTemplate: null
    }, {
        identifier: '370',
        description: null,
        name: 'cash_account$cash_account$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/cash_account',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '371',
        description: null,
        name: 'cash_account$cash_accounts$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/cash_accounts',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '373',
        description: null,
        name: 'cash_account$transaction$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/cash_account/transaction',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '438',
        description: null,
        name: 'person$user_menu$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/person/user_menu',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '441',
        description: null,
        name: 'multiproduct$action_sections$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/multiproduct/action_sections',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }, {
        identifier: '450',
        description: null,
        name: 'credit$credit_actions_status$get',
        image: null,
        alternateName: null,
        url: 'http://54.225.6.218:8080/credit/credit_actions_status',
        additionalType: null,
        status: null,
        modifyUser: null,
        approvalUser: null,
        actionPlatform: null,
        contentType: null,
        encodingType: null,
        httpMethod: 'GET',
        urlTemplate: null
    }
];

class MockService {
    constructor() {
    }
    getEntryPoints() {
        return new Observable(resolve => {
            setTimeout(() => {
                resolve.next(entry_point);
                resolve.complete();
            });
        });
    }
}
/** @nocollapse */ MockService.ɵfac = function MockService_Factory(t) { return new (t || MockService)(); };
/** @nocollapse */ MockService.ɵprov = ɵɵdefineInjectable({ token: MockService, factory: MockService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MockService, [{
        type: Injectable
    }], function () { return []; }, null); })();

// import { JsonService } from '@akeela/workflow';
class PathService {
    constructor(_http, config, mockService, localStorage
    // private _jsonService: JsonService,
    ) {
        this._http = _http;
        this.config = config;
        this.mockService = mockService;
        this.localStorage = localStorage;
        this.searchingService = false;
        this.searchingFront = false;
        this.services = [];
        this.ip = this.config.urlApi;
        this.URLFront = this.config.urlFront;
    }
    getServicesIp() {
        return this.ip;
    }
    getServicesURLFront() {
        return this.URLFront;
    }
    getUrl(param) {
        const url = this.ip + '/getUrl?role=' + param;
        return this._http
            .get(url, { responseType: 'text' })
            .pipe(map(resp => {
            return resp;
        }));
    }
    getUrlsServicesAll() {
        this.searchingService = true;
        const url = this.ip + '/entry_points';
        // console.log('url nano: ', url);
        if (this.config.useMock) {
            return this.mockService.getEntryPoints();
        }
        else {
            if (isNullOrUndefined(this.properties$)) {
                this.properties$ = this._http.get(url).pipe(shareReplay(1));
            }
            return this.properties$;
        }
    }
    getPathService(param, code) {
        return new Observable(resolve => {
            if (this.pathServices) {
                if (code) {
                    resolve.next(this.searchPathServiceCode(code));
                }
                else {
                    resolve.next(this.searchPathService(param));
                }
                resolve.complete();
            }
            else {
                this.searchingService = true;
                this.getUrlsServicesAll().subscribe((result) => {
                    this.pathServices = result;
                    if (code) {
                        resolve.next(this.searchPathServiceCode(code));
                    }
                    else {
                        resolve.next(this.searchPathService(param));
                    }
                    resolve.complete();
                    this.searchingService = false;
                });
            }
        });
    }
    searchPathService(param) {
        const temp = this.pathServices.filter(item => item.name === param);
        if (temp[0]) {
            return temp[0];
        }
        else {
            console.log('No se encontro url para: ', param);
        }
        return false;
    }
    searchPathServiceCode(param) {
        const temp = this.pathServices.filter(item => {
            return item.alternateName === param;
        });
        if (temp[0]) {
            return temp[0];
        }
        else {
            console.log('No se encontro code para: ', param);
        }
        return {};
    }
    getAdditionalType(obj, additionalType) {
        const params = JSON.parse(additionalType);
        return this.getObjectReplaceParams(obj, params);
    }
    getObjectReplaceParams(ThisObj, fn) {
        const params_path = fn.o.params.path ? fn.o.params.path : {};
        const params_request = fn.o.params.request ? fn.o.params.request : {};
        const params_responseType = fn.o.params.responseType ? fn.o.params.responseType : 'json';
        fn.o.params = { "request": {}, "path": {}, "responseType": params_responseType };
        //QUERY PARAMS
        for (let element of Object.keys(params_request)) {
            fn.o.params.request[element] = this.getValObjectResult(params_request[element], ThisObj);
        }
        ;
        //PATH PARAMS
        for (let element of Object.keys(params_path)) {
            fn.o.params.path[element] = this.getValObjectResult(params_path[element], ThisObj);
        }
        ;
        return fn.o;
    }
    getValObjectResult(attributevalue, ThisObj) {
        if (attributevalue.startsWith('this.localStorage.')) {
            const index = attributevalue.replace('this.localStorage.', '');
            return !isNullOrUndefined(this.localStorage.getItem(index)) ? this.localStorage.getItem(index) : null;
        }
        else if (attributevalue.startsWith('this.')) {
            const attribute = attributevalue.replace('this.', '').split('.');
            if (attribute.length > 1) {
                let prov;
                attribute.forEach((element, index) => {
                    if (index === 0) {
                        prov = ThisObj[element];
                    }
                    else {
                        prov = prov[element];
                    }
                });
                return prov;
            }
            else {
                return ThisObj[attributevalue.replace('this.', '')];
            }
        }
        else {
            return attributevalue;
        }
    }
    // getValObjectResult(attributevalue, ThisObj) {
    //     if (attributevalue.startsWith('this.')) {
    //         const attribute = attributevalue.replace('this.', '').split('.');
    //         if (attribute.length > 1) {
    //             let prov;
    //             attribute.forEach((element, index) => {
    //                 if (index === 0) {
    //                     prov = ThisObj[element];
    //                 } else {
    //                     prov = prov[element];
    //                 }
    //             });
    //             return prov;
    //         } else {
    //             return ThisObj[attributevalue.replace('this.', '')];
    //         }
    //     } else {
    //         return attributevalue;
    //     }
    // }
    getUrlsFrontAll() {
        this.searchingFront = true;
        const url = this.ip + '/urls_front';
        if (this.config.useMock) {
            return this.mockService.getEntryPoints();
        }
        else {
            if (isNullOrUndefined(this.propertiesFront$)) {
                this.propertiesFront$ = this._http.get(url).pipe(shareReplay());
            }
            return this.propertiesFront$;
        }
    }
    getPathFront(code) {
        return new Observable(resolve => {
            if (this.pathFront) {
                if (code) {
                    resolve.next(this.searchPathFrontCode(code));
                }
                resolve.complete();
            }
            else {
                this.searchingFront = true;
                this.getUrlsFrontAll().subscribe((result) => {
                    this.pathFront = result;
                    if (code) {
                        resolve.next(this.searchPathFrontCode(code));
                    }
                    resolve.complete();
                    this.searchingService = false;
                });
            }
        });
    }
    searchPathFrontCode(param) {
        const temp = this.pathFront.filter(item => {
            return item.alternateName === param;
        });
        if (temp[0]) {
            return temp[0];
        }
        else {
            console.log('No se encontro codeFront para: ', param);
        }
        return {};
    }
}
/** @nocollapse */ PathService.ɵfac = function PathService_Factory(t) { return new (t || PathService)(ɵɵinject(HttpClient), ɵɵinject(AkeelaPropertiesConfigService), ɵɵinject(MockService), ɵɵinject(LocalService)); };
/** @nocollapse */ PathService.ɵprov = ɵɵdefineInjectable({ token: PathService, factory: PathService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PathService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: AkeelaPropertiesConfigService }, { type: MockService }, { type: LocalService }]; }, null); })();

class HttpService {
    constructor(http, path) {
        this.http = http;
        this.path = path;
        this.request$ = {};
        this.tem_request$ = {};
        this.timer = {};
        this.HttpUpdate$ = new BehaviorSubject(null);
    }
    executeExternalFrontRequestMultipart(pathResponse, form_data, params) {
        return new Observable(resolve => {
            let httpMethod;
            const url = pathResponse.url;
            /*HEADERS*/
            let headers = null;
            if (params.headers) {
                headers = new HttpHeaders(params.headers);
            }
            let data = url;
            let responseType = params.responseType ? params.responseType : 'json';
            if (pathResponse.httpMethod) {
                switch (pathResponse.httpMethod.toLowerCase()) {
                    case 'get':
                        httpMethod = this.http.get(data, {
                            headers: headers,
                            params: params.request,
                            responseType: responseType
                        });
                        break;
                    case 'post':
                        httpMethod = this.http.post(data, form_data, {
                            headers: headers,
                            responseType: params.responseType ? params.responseType : 'json'
                        });
                        break;
                    case 'put':
                        httpMethod = this.http.put(data, params.body, {
                            headers: headers,
                            params: params.request,
                            responseType: params.responseType ? params.responseType : 'json'
                        });
                        break;
                    case 'delete':
                        httpMethod = this.http.request('delete', data, {
                            params: params.request,
                            body: params.body,
                            headers: headers,
                            responseType: params.responseType ? params.responseType : 'json'
                        });
                        break;
                }
                let httpMethodResult = httpMethod.pipe(map((event) => {
                    this.setHttpUpdate(pathResponse.httpMethod.toLowerCase());
                    return event;
                }));
                httpMethodResult.subscribe(response => {
                    resolve.next(response);
                    resolve.complete();
                }, (error) => {
                    resolve.error(error);
                    resolve.complete();
                });
            }
            else {
                resolve.error({});
                resolve.complete();
            }
        });
    }
    executeFrontRequest(obj, code, params, force) {
        return new Observable(resolve => {
            this.path.getPathFront(code).subscribe(response => {
                let url = response.url;
                let request = {};
                if (!isNullOrUndefined(response.additionalType)) {
                    let jsData = JSON.parse(response.additionalType);
                    if (!isNullOrUndefined(jsData.path)) {
                        let objParams = this.getObjectReplaceParams(obj, jsData.path);
                        url = this.replacePathParameters(url, objParams);
                    }
                    if (!isNullOrUndefined(jsData.request)) {
                        request = this.getObjectReplaceParams(obj, jsData.request);
                    }
                }
                resolve.next({ url, request, response });
                resolve.complete();
            });
        });
    }
    setHttpUpdate(type) {
        this.HttpUpdate$.next(type);
    }
    getObjectReplaceParams(ThisObj, objParams) {
        for (let element of Object.keys(objParams)) {
            objParams[element] = this.path.getValObjectResult(objParams[element], ThisObj);
        }
        ;
        return objParams;
    }
    executeRequest(endpoint, params, force) {
        return new Observable(resolve => {
            this.path.getPathService(endpoint).subscribe(pathResponse => {
                let httpMethod;
                const url = pathResponse.url;
                /*HEADERS*/
                let headers = null;
                if (params.headers) {
                    headers = new HttpHeaders(params.headers);
                }
                let data = this.replacePathParameters(url, params.path);
                let responseType = params.responseType ? params.responseType : 'json';
                if (pathResponse.httpMethod) {
                    switch (pathResponse.httpMethod.toLowerCase()) {
                        case 'get':
                            httpMethod = this.http.get(data, {
                                headers: headers,
                                params: params.request,
                                responseType: responseType
                            });
                            const nameRequest = this.getName(endpoint, params);
                            if (!force || (pathResponse.alternateName && pathResponse.alternateName == '$')) {
                                if (isNullOrUndefined(this.request$[nameRequest])) {
                                    this.request$[nameRequest] = httpMethod.pipe(shareReplay());
                                }
                                httpMethod = this.request$[nameRequest];
                            }
                            else {
                                if (this.tem_request$.hasOwnProperty(nameRequest)) {
                                    httpMethod = this.tem_request$[nameRequest];
                                    delete this.tem_request$[httpMethod];
                                    clearTimeout(this.timer[nameRequest]);
                                    this.timer[nameRequest] = setTimeout(() => {
                                        let temp = nameRequest;
                                        delete this.tem_request$[temp];
                                        clearTimeout(this.timer[nameRequest]);
                                    }, 5000);
                                }
                                else {
                                    this.timer[nameRequest] = setTimeout(() => {
                                        let temp = nameRequest;
                                        delete this.tem_request$[temp];
                                    }, 5000);
                                    this.tem_request$[nameRequest] = httpMethod.pipe(shareReplay());
                                }
                            }
                            break;
                        case 'post':
                            httpMethod = this.http.post(data, params.body, {
                                headers: headers,
                                params: params.request,
                                responseType: params.responseType ? params.responseType : 'json'
                            });
                            break;
                        case 'put':
                            httpMethod = this.http.put(data, params.body, {
                                headers: headers,
                                params: params.request,
                                responseType: params.responseType ? params.responseType : 'json'
                            });
                            break;
                        case 'delete':
                            httpMethod = this.http.request('delete', data, {
                                params: params.request,
                                body: params.body,
                                headers: headers,
                                responseType: params.responseType ? params.responseType : 'json'
                            });
                            break;
                    }
                    let httpMethodResult = httpMethod.pipe(map((event) => {
                        this.setHttpUpdate(pathResponse.httpMethod.toLowerCase());
                        return event;
                    }));
                    httpMethodResult.subscribe(response => {
                        resolve.next(response);
                        resolve.complete();
                    }, (error) => {
                        resolve.error(error);
                        resolve.complete();
                    });
                }
                else {
                    resolve.error({});
                    resolve.complete();
                }
            });
        });
    }
    replacePathParameters(url, params) {
        try {
            for (const param of Object.keys(params)) {
                const character = new RegExp('{' + param + '}', 'g');
                url = url.replace(character, params[param]);
            }
        }
        catch (error) {
        }
        return url;
    }
    getName(urlKey, params) {
        const nameArray = [];
        nameArray.push(urlKey);
        Object.keys(params).forEach(key => {
            if (Object.keys(params[key]).length > 0) {
                Object.keys(params[key]).forEach(sKey => {
                    nameArray.push(sKey + '_' + params[key][sKey]);
                });
            }
            else {
                nameArray.push(key + '_' + params[key]);
            }
        });
        return nameArray.join('_');
    }
    executeRequestExternalUrl({ pathResponse, params }) {
        return new Observable(resolve => {
            let httpMethod;
            const url = pathResponse.url;
            /*HEADERS*/
            let headers = null;
            if (params.headers) {
                headers = new HttpHeaders(params.headers);
            }
            let data = url;
            let responseType = params.responseType ? params.responseType : 'json';
            if (pathResponse.httpMethod) {
                switch (pathResponse.httpMethod.toLowerCase()) {
                    case 'get':
                        httpMethod = this.http.get(data, {
                            headers: headers,
                            params: params.request,
                            responseType: responseType
                        });
                        break;
                    case 'post':
                        httpMethod = this.http.post(data, params.body, {
                            headers: headers,
                            params: params.request,
                            responseType: params.responseType ? params.responseType : 'json'
                        });
                        break;
                    case 'put':
                        httpMethod = this.http.put(data, params.body, {
                            headers: headers,
                            params: params.request,
                            responseType: params.responseType ? params.responseType : 'json'
                        });
                        break;
                    case 'delete':
                        httpMethod = this.http.request('delete', data, {
                            params: params.request,
                            body: params.body,
                            headers: headers,
                            responseType: params.responseType ? params.responseType : 'json'
                        });
                        break;
                }
                let httpMethodResult = httpMethod.pipe(map((event) => {
                    this.setHttpUpdate(pathResponse.httpMethod.toLowerCase());
                    return event;
                }));
                httpMethodResult.subscribe(response => {
                    resolve.next(response);
                    resolve.complete();
                }, (error) => {
                    resolve.error(error);
                    resolve.complete();
                });
            }
            else {
                resolve.error({});
                resolve.complete();
            }
        });
    }
}
/** @nocollapse */ HttpService.ɵfac = function HttpService_Factory(t) { return new (t || HttpService)(ɵɵinject(HttpClient), ɵɵinject(PathService)); };
/** @nocollapse */ HttpService.ɵprov = ɵɵdefineInjectable({ token: HttpService, factory: HttpService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HttpService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: PathService }]; }, null); })();

class AkeelaPropertiesModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('AkeelaPropertiesModule is already loaded. Import it in the AppModule only');
        }
    }
    static config(config) {
        return {
            ngModule: AkeelaPropertiesModule,
            providers: [
                { provide: AkeelaPropertiesConfig, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ AkeelaPropertiesModule.ɵmod = ɵɵdefineNgModule({ type: AkeelaPropertiesModule });
/** @nocollapse */ AkeelaPropertiesModule.ɵinj = ɵɵdefineInjector({ factory: function AkeelaPropertiesModule_Factory(t) { return new (t || AkeelaPropertiesModule)(ɵɵinject(AkeelaPropertiesModule, 12)); }, providers: [
        AkeelaPropertiesConfigService,
        MockService,
        PathService,
        HttpService
    ], imports: [[]] });
__decorate([
    __param(0, Optional()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AkeelaPropertiesConfig]),
    __metadata("design:returntype", Object)
], AkeelaPropertiesModule, "config", null);
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaPropertiesModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                exports: [],
                providers: [
                    AkeelaPropertiesConfigService,
                    MockService,
                    PathService,
                    HttpService
                ]
            }]
    }], function () { return [{ type: AkeelaPropertiesModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

/*
 * Public API Surface of akeela-properties
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaPropertiesModule, HttpService, PathService };
//# sourceMappingURL=akeela-properties.js.map
